import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col text-start" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "row mb-4" }
const _hoisted_6 = { class: "col-xxl-6 text-start" }
const _hoisted_7 = {
  for: "customRange3",
  class: "form-label"
}
const _hoisted_8 = { class: "fw-bolder" }
const _hoisted_9 = { class: "d-flex justify-content-between guiide-range-slider" }
const _hoisted_10 = { class: "pe-3" }
const _hoisted_11 = ["min", "max"]
const _hoisted_12 = { class: "ps-3" }
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = { class: "col-xxl-6 text-start" }
const _hoisted_15 = {
  for: "customRange3",
  class: "form-label"
}
const _hoisted_16 = { class: "fw-bolder" }
const _hoisted_17 = { class: "d-flex justify-content-between guiide-range-slider" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "col text-start" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col text-start" }
const _hoisted_24 = { class: "row mb-3" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "container-fluid border border-dark rounded p-3 mb-4" }
const _hoisted_28 = { class: "row pt-2 pb-0" }
const _hoisted_29 = { class: "col-lg-12" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "row mb-2" }
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = {
  key: 2,
  class: "row"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnuityProvidersList = _resolveComponent("AnnuityProvidersList")!
  const _component_income_and_pots = _resolveComponent("income-and-pots")!
  const _component_scenario = _resolveComponent("scenario")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, " Using flexible drawdown income and guaranteed lifetime income (annuities) can provide both secure and flexible income. ", -1)),
        (_ctx.displaySuppliers)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _cache[4] || (_cache[4] = [
              _createTextVNode(" If you wish to consider buying some guaranteed income "),
              _createElementVNode("strong", null, "you can do so via Retirement Line, the UKs largest independent annuity broker below", -1),
              _createTextVNode(". Our model uses Retirement Line's current market rates, but they will ask you further questions on the exact type of annuity you want, where you live, your lifestyle and health to get final rates for you. ")
            ])))
          : _createCommentVNode("", true),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, " You can model an estimate below from any age after retirement. This uses current market annuity single life rates with no increases. Just move the sliders below and click Update Plan to see the effect. ", -1)),
        (_ctx.displaySuppliers)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " If you do buy some guaranteed income you can then model the actual amount bought as other income by updating your plan with the exact amount and how it increases over time. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, [
          _cache[7] || (_cache[7] = _createTextVNode(" Age to add some guaranteed income from: ")),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.ageText), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.minPurchaseAge), 1),
          _withDirectives(_createElementVNode("input", {
            type: "range",
            class: "form-range",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ageModel) = $event)),
            min: _ctx.minPurchaseAge,
            max: _ctx.maxPurchaseAge,
            step: "1"
          }, null, 8, _hoisted_11), [
            [_vModelText, _ctx.ageModel]
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.maxPurchaseAge), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, [
          _cache[8] || (_cache[8] = _createTextVNode(" Percentage of your non protected pension pot used to buy it: ")),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.amountText), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pe-3" }, " 0 ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "range",
            class: "form-range",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amountModel) = $event)),
            min: "0",
            max: 80,
            step: "5"
          }, null, 512), [
            [_vModelText, _ctx.amountModel]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "ps-3" }, "80", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mt-4",
          disabled: _ctx.inTransaction,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdateClicked()))
        }, [
          _cache[11] || (_cache[11] = _createTextVNode(" Update Plan ")),
          _createElementVNode("i", {
            class: _normalizeClass(["bi", _ctx.updateButtonIcon])
          }, null, 2)
        ], 8, _hoisted_18)
      ])
    ]),
    (_ctx.isCurrentlySubscribedToGI)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.showMinimumPurchaseWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, " Please note that there is a minimum purchase amount of " + _toDisplayString(_ctx.minPurchaseAmountFormatted) + ". ", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", null, " You have included a guaranteed income purchase in your plan. " + _toDisplayString(_ctx.guaranteedIncomeSubscriptionText), 1),
              _cache[12] || (_cache[12] = _createElementVNode("p", null, [
                _createTextVNode("Click "),
                _createElementVNode("i", null, "Remove"),
                _createTextVNode(" to go back to just using non guaranteed drawdown income.")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm float-start",
                disabled: _ctx.inTransaction,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUnsubscribeGuaranteedIncomeClicked()))
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("span", { class: "d-none d-sm-inline-block me-2" }, "Remove", -1),
                _createElementVNode("i", { class: "bi bi-dash-circle" }, null, -1)
              ]), 8, _hoisted_26)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.displaySuppliers)
      ? (_openBlock(), _createBlock(_component_AnnuityProvidersList, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_income_and_pots)
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.AccordingToPlan,
            number: "1",
            showBorder: false
          }, null, 8, ["scenario"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.LowerGrowth,
          number: "2",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.LiveThreeYearsLonger,
          number: "3",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.PotsFallTwentyPercent,
          number: "4",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.NeedExtraMoneyForLastTwoYears,
          number: "5",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ])
    ]),
    (_ctx.displaySuppliers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[14] || (_cache[14] = [
          _createElementVNode("div", { class: "col text-start" }, [
            _createElementVNode("p", null, [
              _createElementVNode("small", null, " The calculations above are based on illustrative figures. If you want to buy some guaranteed income you will need to get an actual quote from Retirement Line. This quote will depend on a number of factors such as interest rates on that day and factors that are specific to you such as the annuity type you want, your age, health, postcode and lifestyle. ")
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("small", null, " If you choose to buy an annuity from Retirement Line through our link, we will receive a one off payment from them. This does not cost you anything at all as the annuity will be priced exactly the same as if you went directly. ")
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      ref: "graphModal",
      title: _ctx.graphModalTitle,
      idKey: "graphModal",
      key: "graphModal",
      isWide: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_income_and_pots)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}